export const lang = state => state.lang
export const tabData = state => state.tabData

export const activeTabKey = state => state.activeTabKey
export const drawerInfo = state => state.drawerInfo
export const userInfo = state => state.userInfo
export const otherSystemConfig = state => state.otherSystemConfig
export const callRecords = state => state.callRecords
export const dialogInfo = state => state.dialogInfo

export const floatBarMenu = state => state.floatBarMenu
export const qidianExpand = state => state.qidianExpand
export const todayCallCustomers = state => state.todayCallCustomers



// WEBPACK FOOTER //
// ./src/vuex/getters.js